import { render, staticRenderFns } from "./ModalFeedback.vue?vue&type=template&id=61435bb1&scoped=true"
import script from "./ModalFeedback.vue?vue&type=script&lang=js"
export * from "./ModalFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61435bb1",
  null
  
)

export default component.exports